import styled, { css, DefaultTheme } from 'styled-components'
import { isRedButtonTestActive } from '../../utils/red-button-test'

export const SelectedFiltersWrapper = styled.h2`
    position: relative;
    display: flex;
    gap: 8px;
    overflow-x: auto;
    width: calc(100% + 16px);
    height: 64px;
    max-width: 100%;
    padding-left: 65px;
    scroll-behavior: smooth;
    -webkit-overflow-scrolling: touch;
    -ms-overflow-style: none;
    scrollbar-width: none;
    align-items: center;
    &::-webkit-scrollbar {
        display: none;
    }

    @media (max-width: 768px) {
        & > :last-child {
            margin-right: 16px;
        }
    }
    @media (min-width: 768px) {
        overflow-x: hidden;
        padding-left: 2px;
        margin-left: 0;
        max-width: 100%;
        scrollbar-color: ${({ theme }) => theme.color.bgFill.disabled} transparent;
    }
`

const buttonPillColors = (theme: DefaultTheme) => {
    return {
        buttonBackground: isRedButtonTestActive
            ? theme.color.bgFill.brand.default
            : theme.color.button.bgFill.primary.default,
        buttonHover: isRedButtonTestActive ? theme.color.bgFill.brand.hover : theme.color.button.bgFill.primary.hover,
    }
}

export const StyledMobileFilterAndSort = styled.button<{
    $exceedsWidth?: boolean
    styleMovement?: number
}>`
    position: relative;
    display: flex;
    align-items: center;
    height: 52px;
    width: 52px;
    border: none;
    border-radius: 52px;
    padding: 8px 16px;
    background-color: ${({ theme }) => buttonPillColors(theme).buttonBackground};
    cursor: pointer;
    svg {
        fill: ${({ theme }) => theme.color.icon.inputMarker.onFill};
    }
    &:hover {
        background-color: ${({ theme }) => buttonPillColors(theme).buttonHover};
    }
    &:focus,
    &:focus-visible {
        outline: ${({ theme }) => `2px solid ${theme.color.border.focus}`};
    }
`

export const PillCount = styled.div`
    position: absolute;
    display: flex;
    justify-content: center;
    align-items: center;
    height: 18px;
    width: 18px;
    padding: 4px;
    border: 1px solid ${({ theme }) => theme.color.border.soft};
    border-radius: 50%;
    background-color: ${({ theme }) =>
        isRedButtonTestActive ? theme.color.bgFill.intense : theme.color.bgFill.notification};
    color: ${({ theme }) => theme.color.text.offer.onFill};
    font-size: 10px;
    font-variation-settings: 'wght' 400;
    top: 0;
    right: -2px;
`

export const CarouselButtons = styled.button`
    border-radius: 20px;
    border: none;
    height: 32px;
    width: 32px;
    cursor: pointer;
    display: flex;
    justify-content: center;
    padding: 4px;
    align-items: center;
    background: ${({ theme }) => theme.color.button.bgFill.contrast.active};
    svg {
        fill: ${({ theme }) => theme.color.icon.default};
    }
`

export const CarouselContainer = styled.div<{ rightSide?: boolean }>`
    display: flex;
    align-items: center;
    position: absolute;
    flex-direction: row-reverse;
    height: 100%;
    background-color: ${({ theme }) => theme.color.bgSurface.default};
    z-index: 500;
    ${({ rightSide }) =>
        rightSide
            ? css`
                  right: 190px;
                  padding-left: 6px;
              `
            : css`
                  left: 0;
                  padding-right: 6px;
              `}

    gap: 8px;
    & > .hidden {
        & > button {
            display: none;
        }
    }
`
